
import { useEffect, useState } from 'react';

import { emergencyService } from 'services/emergency.service';
const useEmergencyList = (payload = { skip: 0, limit: 3 }) => {
  const [data, setData] = useState()


  const getMissingPerson = async () => {

    const response = await emergencyService.emergencyList(payload)

    setData(response?.data?.data)

  }
  useEffect(() => {
    getMissingPerson();
  }, [payload?.type, payload?.limit])
  return { emergencyData: data };
}
export default useEmergencyList